import { render, staticRenderFns } from "./FispqUploadAndRegisterChemicalAgentsModal.vue?vue&type=template&id=2df3b52b&scoped=true&"
import script from "./FispqUploadAndRegisterChemicalAgentsModal.vue?vue&type=script&lang=js&"
export * from "./FispqUploadAndRegisterChemicalAgentsModal.vue?vue&type=script&lang=js&"
import style0 from "./FispqUploadAndRegisterChemicalAgentsModal.vue?vue&type=style&index=0&id=2df3b52b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df3b52b",
  null
  
)

export default component.exports